import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { FileSignature } from "lucide-react";
import { fmtDate } from "@/lib/datetime";

export const hipaaStatus = (row) => {
  if (row?.request?.status === "signed" || (row?.doc && !row?.request)) return "signed";
  if (row?.request?.status === "sent") return "sent";
  return "none";
};

const TONE = {
  signed: "text-emerald-600 hover:text-emerald-700",
  sent: "text-amber-500 hover:text-amber-600",
  none: "text-muted-foreground hover:text-primary",
};

// Users tab (drivers only): email the HIPAA template; icon color = Not sent / Sent / Signed.
export function HipaaSendButton({ user, row, onSent }) {
  const [busy, setBusy] = useState(false);
  const status = hipaaStatus(row);
  const title =
    status === "signed" ? `HIPAA signed${row?.request?.signed_at ? ` ${fmtDate(row.request.signed_at)}` : ""} — click to resend`
    : status === "sent" ? `HIPAA sent ${fmtDate(row.request.sent_at)} — waiting for signature (click to resend)`
    : "Send HIPAA document for signature";

  const send = async () => {
    if (!user.email) return toast.error("This driver has no email on file");
    const verb = status === "none" ? "Send" : "Resend";
    if (!window.confirm(`${verb} the HIPAA document to ${user.name || user.email} (${user.email}) for signature?`)) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/hipaa/drivers/${user.id}/send`);
      if (data.email_sent) toast.success(`HIPAA document emailed to ${data.to}`);
      else toast.error(`Email failed (${data.error}). Share this link manually: ${data.fallback_url}`, { duration: 15000 });
      onSent?.();
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={send}
      disabled={busy}
      className={`h-8 w-8 ${TONE[status]}`}
      data-testid={`user-hipaa-send-${user.id}`}
      data-status={status}
      title={title}
    >
      <FileSignature className={`h-4 w-4 ${busy ? "animate-pulse" : ""}`} />
    </Button>
  );
}
